export const messages = {
  en: {
    merchantManage: {
      search: {
        title: 'Search Conditions',
        storeId: 'Please enter merchant ID',
        name: 'Please enter name',
        tel: 'Please enter phone number'
      },
      list: {
        title: 'Merchant Companies',
        manage: 'Manage'
      },
      table: {
        storeId: 'ID',
        name: 'Name',
        address: 'Address',
        tel: 'Phone',
        createTime: 'Create Time'
      },
      fetchError: 'Failed to fetch merchant data'
    }
  },
  zh: {
    merchantManage: {
      search: {
        title: '查询条件',
        storeId: '请输入商家编号',
        name: '请输入名称',
        tel: '请输入电话'
      },
      list: {
        title: '商家公司',
        manage: '管理'
      },
      table: {
        storeId: '编号',
        name: '名称',
        address: '地址',
        tel: '电话',
        createTime: '创建时间'
      },
      fetchError: '获取商家数据失败'
    }
  },
  'zh-TW': {
    merchantManage: {
      search: {
        title: '查詢條件',
        storeId: '請輸入商家編號',
        name: '請輸入名稱',
        tel: '請輸入電話'
      },
      list: {
        title: '商家公司',
        manage: '管理'
      },
      table: {
        storeId: '編號',
        name: '名稱',
        address: '地址',
        tel: '電話',
        createTime: '創建時間'
      },
      fetchError: '獲取商家數據失敗'
    }
  }
}